export const NO_IMAGE = '/public/images/no-image.svg';
